import { useCallback, useEffect, useState } from 'react';
import useQueryString from '../../hooks/useQueryString';

export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];
export const DEFAULT_PAGE = 1;

interface UsePaginationOptions {
  keepPaginationInUrl?: boolean;
}

export const usePagination = (
  initRowsPerPage?: number, 
  initPage?: number, 
  options?: UsePaginationOptions
) => {
  const [page, setPage] = useState(initPage || DEFAULT_PAGE);
  const [rowsPerPage, setRowsPerPage] = useState(initRowsPerPage || ROWS_PER_PAGE_OPTIONS[0]);
  const { queryString, setQueryString } = useQueryString();
  
  const { keepPaginationInUrl = true } = options || {};

  const handlePagination = (value: number, updateURL = keepPaginationInUrl) => {
    setPage(value);

    if (updateURL && keepPaginationInUrl) {
      const updatedParams: Record<string, string | number> = Object.fromEntries(queryString.entries());
      updatedParams.page = value;

      setQueryString(updatedParams);
    }
  };

  const handleRowsPerPage = useCallback((value: number) => {
    setRowsPerPage(value);
    setPage(DEFAULT_PAGE);
  }, []);

  useEffect(() => {
    if (initRowsPerPage) {
      setRowsPerPage(initRowsPerPage);
    }

    if (initPage) {
      setPage(initPage);
    }
  }, [initRowsPerPage, initPage]);

  return {
    page,
    rowsPerPage,
    handlePagination,
    handleRowsPerPage,
  };
};
